// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDbjTaHDuVR53Nq6MvqqbRejDsY9RW5Hrw",
    authDomain: "maria-ewc.firebaseapp.com",
    databaseURL: "https://maria-ewc.firebaseio.com",
    projectId: "maria-ewc",
    storageBucket: "maria-ewc.appspot.com",
    messagingSenderId: "774106016965",
    appId: "1:774106016965:web:40f701a7c9f62cd4df54ac",
    measurementId: "G-33KK7KR21C"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
